var map = {
	"./sticker_blue_balloon_blue.png": 3484,
	"./sticker_blue_bear_blue.png": 121,
	"./sticker_blue_bow_blue.png": 7262,
	"./sticker_blue_cat_blue.png": 6218,
	"./sticker_blue_checker_heart_blue.png": 795,
	"./sticker_blue_cloud_blue.png": 3386,
	"./sticker_blue_clover_blue.png": 5387,
	"./sticker_blue_computer_blue.png": 914,
	"./sticker_blue_crown_blue.png": 1679,
	"./sticker_blue_dog_blue.png": 4234,
	"./sticker_blue_dolphin_blue.png": 8217,
	"./sticker_blue_flip_phone_blue.png": 1966,
	"./sticker_blue_flower_blue.png": 6446,
	"./sticker_blue_game_controller_blue.png": 2717,
	"./sticker_blue_heart_blue.png": 4869,
	"./sticker_blue_love_heart_blue.png": 216,
	"./sticker_blue_pixel_heart_blue.png": 2388,
	"./sticker_blue_planet_blue.png": 3594,
	"./sticker_blue_rabbit_white_blue.png": 8345,
	"./sticker_blue_shooting_star_blue.png": 423,
	"./sticker_blue_smiley_blue.png": 3793,
	"./sticker_blue_speech_bubble_blue.png": 1507,
	"./sticker_blue_star_blue.png": 165,
	"./sticker_blue_star_outline_blue.png": 116,
	"./sticker_blue_star_outline_blue_2.png": 2537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1657;